import { Component, OnInit } from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {DefaultSettingsService} from '../../default-settings-service.service';
import {ExcRestService} from 'exc-rest';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-modal-edit-selfcheck',
  templateUrl: './modal-edit-selfcheck.component.html',
  styles: []
})
export class ModalEditSelfcheckComponent extends ExcTranslation implements OnInit {
  showErrorMessage = false;
  isPreselected = false;
  scAnnounced = true;
  scFixedDuration: number = null;
  scFixedFromHour: number;
  scFixedToHour: number;
  scSendMailHour: number;
  sc: {AuditAnnouncementDate: any, AuditStartDate: any, AuditEndDate: any, AuditDuration: number, Mode: string, Quota: number, Min: number, Max: number, SelectedItems: number, AuditUPT: string, Comment: string};
  optScModes: {text: string, value: string, disabled: boolean}[] = [];
  datepickerConfigAnnouncement: any = {
    // minDate: new Date(),
    // maxDate: (new Date()).setFullYear((new Date()).getFullYear() + 5),
    altInput: true,
    allowInput: true,
    // dateFormat: this.getGlobal('FormatDate'),
    formatDate: (date, format, locale) => {
      if (date === undefined || date === null) {
        return '';
      }
      return this.datePipe.transform(date, this.getGlobal('FormatDateTimeShort'));
    },
    static: true,
    // enableTime: true,
    mode: 'single' // "single", "multiple", or "range" (currently only single is implemented completely
  };
  datepickerConfigStart: any = {
    // minDate: new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate(), 0, 0, 0),
    // maxDate: (new Date()).setFullYear((new Date()).getFullYear() + 5),
    altInput: true,
    allowInput: true,
    // dateFormat: this.getGlobal('FormatDate'),
    formatDate: (date, format, locale) => {
      if (date === undefined || date === null) {
        return '';
      }
      return this.datePipe.transform(date, this.getGlobal('FormatDateTimeShort'));
    },
    static: true,
    // enableTime: true,
    mode: 'single' // "single", "multiple", or "range" (currently only single is implemented completely,
  };
  datepickerConfigEnd: any = {
   //  minDate: new Date(),
   // maxDate: (new Date()).setFullYear((new Date()).getFullYear() + 5),
    altInput: true,
    allowInput: true,
    // dateFormat: this.getGlobal('FormatDate'),
    formatDate: (date, format, locale) => {
      if (date === undefined || date === null) {
        return '';
      }
      return this.datePipe.transform(date, this.getGlobal('FormatDateTimeShort'));
    },
    static: true,
    // enableTime: true,
    mode: 'single' // "single", "multiple", or "range" (currently only single is implemented completely
  };
  constructor(
    private overlayRef: OverlayRef
    , private overlayConfig: OverlayConfig
    , private excDss: DefaultSettingsService
    , private excRest: ExcRestService
    , private datePipe: DatePipe
  ) {
    super();
    const _self = this;

    _self.sc = {AuditAnnouncementDate: new Date(), AuditStartDate: new Date(), AuditEndDate: new Date(), AuditDuration: null, Mode: 'Complete', Quota: null, Min: null, Max: null, SelectedItems: null, AuditUPT: null, Comment: null};
    // _self.optScModes.push({value: 'Complete', text: this.getRessource('ModeComplete'), disabled: false});
    // _self.optScModes.push({value: 'Quota', text: this.getRessource('ModeQuota'), disabled: false});
    // _self.optScModes.push({value: 'Picked', text: this.getRessource('ModePicked'), disabled: true});
    if (this.excDss.MandantSettings.AuditTypes.Digital.Complete.Visible === true) {
      this.optScModes.push({value: 'Complete', text: this.excDss.MandantSettings.AuditTypes.Digital.Complete.Text || this.getRessource('ModeComplete'), disabled: false});
    }

    if (this.excDss.MandantSettings.AuditTypes.Digital.Quota.Visible === true) {
      this.optScModes.push({value: 'Quota', text: this.excDss.MandantSettings.AuditTypes.Digital.Quota.Text || this.getRessource('ModeQuota'), disabled: false});
    }

    if (this.excDss.MandantSettings.AuditTypes.Digital.Picked.Visible === true) {
      this.optScModes.push({value: 'Picked', text: this.excDss.MandantSettings.AuditTypes.Digital.Picked.Text || this.getRessource('ModePicked'), disabled: false});
    }
  }

  ngOnInit() {
    const _self = this;

    _self.scAnnounced = _self.overlayConfig.data['ScAnnounced'];
    _self.scFixedDuration = _self.overlayConfig.data['ScFixedDuration'];
    _self.scFixedFromHour = _self.overlayConfig.data['ScFixedFromHour'];
    _self.scFixedToHour = _self.overlayConfig.data['ScFixedToHour'];
    _self.scSendMailHour = _self.overlayConfig.data['ScSendMailHour'];

    _self.sc.AuditAnnouncementDate = _self.overlayConfig.data.AuditSelfcheckAnnounceDate;
    _self.sc.AuditStartDate = _self.overlayConfig.data.AuditSelfcheckValidFrom;
    _self.sc.AuditEndDate = _self.overlayConfig.data.AuditSelfcheckValidTo;
    _self.sc.AuditDuration = _self.overlayConfig.data.AuditSelfcheckHours;
    _self.sc.Quota = _self.overlayConfig.data.AuditSelfcheckQuota;
    _self.sc.Min = _self.overlayConfig.data.AuditSelfcheckMinimum;
    _self.sc.Max = _self.overlayConfig.data.AuditSelfcheckMaximum;
    _self.sc.AuditUPT = _self.overlayConfig.data.AuditUPT;

    if (_self.overlayConfig.data.AuditIsPicked === true) {
      _self.sc.Mode = 'Picked';
      _self.sc.SelectedItems = _self.overlayConfig.data.ScPickedStock;
    } else {
      if (_self.sc.Quota === null) {
        _self.sc.Mode = 'Complete';
      } else {
        _self.sc.Mode = 'Quota';
      }
    }

    if (_self.scFixedDuration !== null) {
      _self.sc.AuditDuration = _self.scFixedDuration;
    }

    _self.handleAuditStartChanged();
    _self.handleAuditAnnouncementChanged();
    _self.handleAuditEndChanged();
  }

  EditSc() {
    const _self = this;

    if ( (_self.scAnnounced && _self.sc.AuditAnnouncementDate > _self.sc.AuditStartDate)
        || _self.sc.AuditEndDate < _self.sc.AuditStartDate) {
      this.showErrorMessage = true;
      return;
    }

    this.showErrorMessage = false;
    // _self.sc.AuditAnnouncementDate = (_self.scAnnounced === true ? _self.fuckDate(_self.sc.AuditAnnouncementDate) : null);
    // _self.sc.AuditStartDate = _self.fuckDate(_self.sc.AuditStartDate);
   // _self.sc.AuditEndDate = _self.fuckDate(_self.sc.AuditEndDate);
    _self.sc.Quota = _self.sc.Mode === 'Quota' ? _self.sc.Quota : null;
    _self.sc.Min = _self.sc.Mode === 'Quota' ? _self.sc.Min : null;
    _self.sc.Max = _self.sc.Mode === 'Quota' ? _self.sc.Max : null;
    _self.overlayRef.close({proceed: true, Audit: _self.sc});
  }
  handleAuditAnnouncementChanged() {
    if (this.sc.AuditAnnouncementDate !== null) {
      const x = new Date(this.sc.AuditAnnouncementDate);
      x.setHours(this.scSendMailHour, 0, 0);
      this.sc.AuditAnnouncementDate = x.getTime();
    }
  }
  handleAuditStartChanged() {
    // const _self = this;
    // _self.datepickerConfigAnnouncement.maxDate = (_self.sc.AuditStartDate === null ? (new Date()).setFullYear((new Date()).getFullYear() + 5) : _self.sc.AuditStartDate );
    // _self.datepickerConfigEnd.minDate = (_self.sc.AuditStartDate === null ? new Date() : _self.sc.AuditStartDate);
   // this.datepickerConfigAnnouncement.maxDate = (this.sc.AuditStartDate === null ? (new Date()).setFullYear((new Date()).getFullYear() + 5) : this.sc.AuditStartDate );
   // this.datepickerConfigEnd.minDate = (this.sc.AuditStartDate === null ? new Date() : this.sc.AuditStartDate);
    if (this.sc.AuditStartDate !== null) {
      const x = new Date(this.sc.AuditStartDate);
      x.setHours(this.scFixedFromHour, 0, 0);
      this.sc.AuditStartDate = x;
    }
    if (this.scFixedDuration !== null && this.sc.AuditStartDate !== null) {
      const x = new Date(this.sc.AuditStartDate);
      const x2 = new Date(x.getTime() + (this.scFixedDuration * 60 * 60 * 1000));
      this.sc.AuditEndDate = x2;
    }
  }
  handleAuditEndChanged() {
    // const _self = this;
    // _self.datepickerConfigStart.maxDate = (_self.sc.AuditEndDate === null ? (new Date()).setFullYear((new Date()).getFullYear() + 5)  : _self.sc.AuditEndDate);
    if (this.scFixedDuration === null) {
     // this.datepickerConfigStart.maxDate = (this.sc.AuditEndDate === null ? (new Date()).setFullYear((new Date()).getFullYear() + 5) : this.sc.AuditEndDate);
      if (this.sc.AuditEndDate !== null) {
        const x = new Date(this.sc.AuditEndDate);
        x.setHours(this.scFixedToHour, 0, 0);
        this.sc.AuditEndDate = x;
      }
    }
  }
  getFixedEndDate() {
    const _self = this;
    if (this.sc.AuditEndDate !== null) {
      return _self.datePipe.transform(_self.sc.AuditEndDate, _self.getGlobal('FormatDateTimeShort'));
    }
    return '';

  }
}
